import React from 'react'
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import ShopInnerBanner from "./Views/ShopInnerBanner"
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import {
    UiContentWr,

} from "../../components/common/UiPageElements"
import OrderContent from "./Views/OrderContent"
import OrderPointSection from "./Views/OrderPointSection"
import Footer from "../../components/footer/Footer"

export default function OrderConfirmation(props) {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <ShopInnerBanner title="Order Confirmation"
                    description="Product Description Text" />
                <UiBannerBottomBar
                    prevPage="Shop"
                    prevPageLink="/ui"
                    currentPage="Product Name"
                    currentPageLink="/ui/incentives-pre-register" />
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="4" xl="4">
                            <OrderPointSection/>
                        </UiCol>
                        <UiCol lg="8" xl="8">
                            <OrderContent/>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <Footer />
            </UiMainWrapper>
        </>
    )
}
